import {EntryHomepage} from '../EntryHomepage.ts'
import {UIGameSpriteHandler} from '../../../shared/scripts/UIGameSpriteHandler.ts'
import {UIReplayController} from '../../../shared/scripts/ui_replay/UIReplayController.ts'
import {getReplayInitiationData, getReplayUrlActionIndex} from '../../../shared/scripts/ui_replay/ReplayUrlUtilities.ts'

class EntryReplay extends EntryHomepage {
    async initialize() {
        await super.initialize()

        void UIGameSpriteHandler.continueAfterAssetsLoad(async() => {
            const href = window.location.href
            const replayInitiationData = await getReplayInitiationData(href)
            const replayActionIndex = getReplayUrlActionIndex(href)
            const isLiveReplay = false
            new UIReplayController(replayInitiationData, this.socketActionController, isLiveReplay, replayActionIndex)
        })
    }
}

const replay = new EntryReplay()
void replay.initialize()
